import withSecurity from 'views/enhancers/withSecurity'
import loadable from 'loadable-components'
import { TYPES } from 'constants/user'

export const customPageRoutes = [
  {
    path: '/',
    name: 'CustomPageLogin',
    component: loadable(() => import('views/pages/CustomPages/CustomPageLogin')),
    exact: true,
    sitemap: false,
  },
  {
    path: '/delivery',
    name: 'CustomPageDelivery',
    component: loadable(() => import('views/pages/CustomPages/CustomPageDelivery')),
    exact: true,
    sitemap: false,
  },
]

export const publicLandingPageRoutes = [
  {
    path: '/landing/:id',
    name: 'PublicLandingPage',
    component: loadable(() => import('views/pages/PublicLandingPage')),
    exact: true,
    sitemap: false,
  },
]

export const previewRoutes = [
  {
    path: '/preview',
    name: 'Preview',
    component: withSecurity(
      loadable(() => import('views/pages/CustomPages/PreviewPage')),
      false,
      [TYPES.FREIGHT_FORWARDER],
    ),
    exact: true,
    sitemap: false,
  },
]
